import { Type } from "@angular/core";
import {LabelPieceComponent} from './label-piece.component';

/*export * from "./filter.component";*/

export const LABEL_PIECE_DIRECTIVES: Type<any>[] = [
    LabelPieceComponent
];
